<div class="flex-shrink-1">
  <span *ngFor="let step of stepsArray">
    <span class="ball" [class.onOrBefore]="step <= currentStep">{{ step + 1 }}</span>
    <span *ngIf="steps > step + 1" class="link" [class.onOrBefore]="step < currentStep"></span>
  </span>
  <span class="link" [class.onOrBefore]="currentStep == steps"></span>
  <span class="ball" [class.onOrBefore]="currentStep == steps"><i class="fa fa-check"></i></span>
</div>
